import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../../_metronic/layout";
import "../../Game/AddGame/formcontrol.css";
import "../../../../_metronic/_assets/sass/customstyle.react.scss";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  Input,
} from "../../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";
import DropdownReactSelect from "../../../components/DropdownReactSelect";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const CommonForm = (props) => {
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const { id } = useParams();
  const [
    companySelectedDropdownFilterData,
    setCompanySelectedDropdownFilterData,
  ] = useState(null);
  const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
    []
  );
  let history = useHistory();
  const [frmInitialValues, setFrmInitialValues] = useState({
    name: "",
    code: "",
    isGamerjiAds: true,
    isFbAds: true,
    isActive: true,
    company: "",
  });

  // Validation schem
  const APKScreensEditSchema = Yup.object().shape({
    name: Yup.string()
    .required("Name is required"),
    code: Yup.string().required("Name is required"),
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.apkScreenList }),
    shallowEqual
  );
  const { actionsLoading, apkScreenForEdit, company } = currentState;
  useEffect(() => {
    dispatch(actions.fetchCompanyList());
  }, []);

  useEffect(() => {
    let tempb = [];
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userdata?.company || [];

    for (let i = 0; i < company?.length; i++) {
      // if (!helperFunc.isAdmin()) {
        if (userCompany.includes(company[i]._id)) {
          let obj = {};
          obj.label = company[i]?.name;
          obj.value = company[i]?._id;
          obj.code = company[i]?.code;
          tempb.push(obj);
        }
      // } else {
      //   let obj = {};
      //   obj.label = company[i]?.name;
      //   obj.value = company[i]?._id;
      //   obj.code = company[i]?.code;
      //   tempb.push(obj);
      // }
    }

    setCompanyDropdownFilterData(tempb);
  }, [company]);
  useEffect(() => {
    dispatch(actions.fetchSingle(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New APK Screen";
    if (apkScreenForEdit && id) {
      _title = `Edit APK Screen '${apkScreenForEdit?.item &&
        apkScreenForEdit?.item?.name}'`;
      const item = apkScreenForEdit?.item;
      const data = { ...frmInitialValues, ...item };
      setCompanySelectedDropdownFilterData({
        value: apkScreenForEdit?.company?._id,
        label: apkScreenForEdit?.company?.name,
      });
      setFrmInitialValues(data);
    }
    setTitle(_title);
    suhbeader.setTitle(_title);
  }, [apkScreenForEdit, id]);

  const saveAPKScreen = (values) => {
    // Array to store error messages
    let errorMessages = [];

    // Perform validation checks
    if (!values.name) {
      errorMessages.push("Name is required");
    }
    if (!values.code) {
      errorMessages.push("Code is required");
    }
    if (!companySelectedDropdownFilterData) {
      errorMessages.push("Please select a company");
    }

    // If there are any error messages, display them together

    if (errorMessages.length > 0) {
      errorMessages.forEach((errorMessage) => {
        NotificationManager.error(errorMessage, "Error");
      });
      return;
    }

    // If all validations pass, proceed with saving
    values.company = companySelectedDropdownFilterData?.code;
    if (!id) {
      // Create new item
      dispatch(actions.createItem(values)).then((success) => {
        if (success) {
          // NotificationManager.success("Country created successfully!"); // Display success toast
          setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
        }
      });
    } else {
      // Update existing item
      dispatch(actions.updateItem(values, id)).then((success) => {
        if (success) {
          // NotificationManager.success("Country updated successfully!"); // Display success toast
          setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
        }
      });
    }
  };

  const backToList = () => {
    history.push(`/apkscreen/list`);
    window.location.reload();
  };

  return (
    <>
      <NotificationContainer />
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title}></CardHeader>
        <CardBody>
          <Formik
            enableReinitialize={true}
            initialValues={frmInitialValues}
            validationSchema={APKScreensEditSchema}
            onSubmit={(values) => {
              saveAPKScreen(values);
            }}
          >
            {({ handleSubmit, values }) => (
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-lg-4 col-md-6 mt-2">
                    <label>
                      Select Company{" "}
                      <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                    </label>
                    {console.log("testttt", frmInitialValues)}
                    <DropdownReactSelect
                      placeholder={"Select Company"}
                      name={"companies"}
                      value={
                        companySelectedDropdownFilterData ||
                        frmInitialValues?.company
                      }
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      isDisabled={apkScreenForEdit?.company ? true : false}
                      closeMenuOnSelect={true}
                      options={companyDropdownFilterData}
                      onChange={setCompanySelectedDropdownFilterData}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 mt-2">
                    <Field
                      // className="form-controll"
                      name="name"
                      component={Input}
                      placeholder="Name"
                      label="Name"
                      isRequired={true}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 mt-2">
                    <Field
                      // className="form-controll"
                      name="code"
                      component={Input}
                      placeholder="Code"
                      label="Code"
                      isRequired={true}
                      disabled={id ? true : false}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  {/* <div className="col-lg-4 col-md-6 mt-2 mt-3">
                <div role="group" aria-labelledby="my-radio-group" className="radio-inline">
                    <label className="mr-3 col-4 p-0">Is Gamerji Ads : </label>
                    <label className="radio">
                        <Field type="radio" name="isGamerjiAds" value={'true'} />
                        <span></span>Active
                    </label>
                    <label className="radio">
                        <Field type="radio" name="isGamerjiAds" value={'false'} />
                        <span></span>DeActive
                    </label>
                </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-2 mt-3">
                <div role="group" aria-labelledby="my-radio-group" className="radio-inline">
                    <label className="mr-3 col-4 p-0">Is Facebook Ads : </label>
                    <label className="radio">
                        <Field type="radio" name="isFbAds" value={'true'} />
                        <span></span>Active
                    </label>
                    <label className="radio">
                        <Field type="radio" name="isFbAds" value={'false'} />
                        <span></span>DeActive
                    </label>
                </div>
            </div> */}
                  <div className="col-lg-2 col-6 mt-3">
                    <label className="col-12 col-form-label">
                      Is Gamerji Ads
                    </label>
                    <div className="col-12">
                      <span className="switch switch-primary switch-icon">
                        <label>
                          <Field type="checkbox" name="isGamerjiAds" />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-2 col-6 mt-3">
                    <label className="col-12 col-form-label">
                      Is Facebook Ads
                    </label>
                    <div className="col-12">
                      <span className="switch switch-primary switch-icon">
                        <label>
                          <Field type="checkbox" name="isFbAds" />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-2 col-6 mt-3">
                    <label className="col-12 col-form-label">Is Active</label>
                    <div className="col-12">
                      <span className="switch switch-primary switch-icon">
                        <label>
                          <Field type="checkbox" name="isActive" />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group justify-content-end row mx-0">
                  <button
                    type="button"
                    onClick={backToList}
                    className="btn btn-light"
                  >
                    <i className="fa fa-arrow-left"></i>Back
                  </button>
                  {helperFunc.isButtonAccess("master.apkScreen.add", "add") && (
                  <button type="submit" className="btn btn-primary ml-2">
                  {id ? "Update" : "Save"}
                  </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </>
  );
};
export default CommonForm;
